import { observer } from 'mobx-react-lite'
import { ChatbotProvider } from '@breakoutlearning/firebase-repository/types'
import { useFeatureFlags } from 'hooks/featureFlags'
import { HubSpotChatController } from './HubSpotChatController'
import { IntercomController } from './IntercomController'

/**
 * Picks which support chatbot mounts, from the `chatbotProvider` feature flag.
 * Renders nothing itself.
 *
 * Fails closed: the schema resolves anything it doesn't recognise - a typo, an
 * empty string, an absent flag - to `none`, and `none` mounts no chatbot at
 * all. A bot only ever appears because someone chose it explicitly, so the flag
 * has to be set in Firestore before either one shows up.
 *
 * Switching providers at runtime is safe. Each controller tears its own widget
 * down on unmount, so flipping the flag swaps one for the other rather than
 * stacking two launchers in the same corner of the screen.
 */
export const ChatbotController = observer(function ChatbotController() {
  const { chatbotProvider } = useFeatureFlags()

  switch (chatbotProvider) {
    case ChatbotProvider.hubspot:
      return <HubSpotChatController />
    case ChatbotProvider.fin:
      return <IntercomController />
    default:
      return null
  }
})
